import { generateTypes } from '../utils/HttpReducerHelper';

export const leads = generateTypes('LEAD', 'LEADS');
